module.exports = __webpack_public_path__ + "static/media/store-banner.6f780892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/store-banner.jpg
// module id = 2025
// module chunks = 6